export const getSpezialFarbname = (colorCode: string) => {
    if (!hatSpezialname(colorCode)) {
        return colorCode;
    }
    return colorCodeSpezialNamen[colorCode];
}


const colorCodeSpezialNamen = {
    "K": "km_kragen",
    "BW": "km_bwcolorlabel",
    "RV": "km_RV",
    "VTL": "km_rueckennetz",
    "SL": "km_einfassband",
    "SLL": "km_einfassband",
    "SLR": "km_einfassband",
    "HoBo": "km_polyamid",
    "TR-Tex": "km_polyamid",
    "STL": "km_polyamid",
    "SC": "km_schild"
}


export const hatSpezialname = (colorCode: string) => {
    return Object.keys(colorCodeSpezialNamen).indexOf(colorCode)>-1
}